import order from './order';
import dealer from './dealer';
import base from './base';
import warehouse from './ims/warehouse'; // 仓库
import stock from './ims/stock'; // 库存
import account from './ims/account'; // 账户
import company from './ims/company'; // 物流公司
import member from './mcc/member'; // 会员
import menuList from './syssetting/menuList'; // 菜单
import urlList from './syssetting/urlList'; // Url
import functionList from './syssetting/functionList'; // 功能
import roleList from './syssetting/roleList'; // 角色
import auth from './syssetting/auth'; // 角色授权
import systemList from './system/systemList'; // 系统
import userList from './user/userList'; // 用户
import orgList from './org/orgList'; // 组织
import region from './cmc/region'; // 区域
import dictionary from './dictionary/dictionary'; // 字典
import product from './pmc/product'; // 商品
import caseList from './cms/caseList'; // 案例分享 (包括案例列表和案例类型类别的CRUD)
import productType from './pmc/productType'; // 商品类别
import webSimpleColumn from './cms/webSimpleColumn'; // 网页发布
import dear from './cmc/dear';
import designList from './mcc/designList';
import tips from './cms/tips'; // 提示
import roomList from './cms/roomList'; // 展厅
import address from './mcc/address'; // 地址
import campaign from './mmc/campaign'; // 活动
import ticket from './mmc/ticket'; // 小票
import memberCoupon from './mmc/coupon'; // 会员优惠券
import eurlateProduct from './mmc/product'; // 品项
import eventNotice from './mmc/eventNotice'; // 活动通知
import eurlateStore from './mmc/store'; // 门店
import store from './cmc/store'; // 门店
import memberLevel from './mmc/memberLevel' // 会员层级
import memberLabel from './mmc/memberLabel' // 会员标签
import checkStock from './ims/checkStock'
import myg from './myg/myg'
import mygTask from './myg/task'
import knowledgeBase from './mmc/knowledgeBase' // 知识库

export default {
  order,
  dealer,
  base,
  warehouse,
  account,
  company,
  stock,
  member,
  menuList,
  urlList,
  systemList,
  functionList,
  roleList,
  auth,
  userList,
  region,
  dear,
  orgList,
  dictionary,
  roomList,
  product,
  caseList,
  webSimpleColumn,
  productType,
  designList,
  tips,
  address,
  ticket,
  memberCoupon,
  eurlateProduct,
  eurlateStore,
  store,
  campaign,
  eventNotice,
  memberLevel,
  memberLabel,
  myg,
  mygTask,
  checkStock,
  knowledgeBase
}



// WEBPACK FOOTER //
// ./src/request/index.js